/*
 * Copyright © 2025. Legalbird eine Marke der Legalbird GmbH
 */

import { FormTransformations } from "../../../types/ProductService/ProductService";
import abstractCaseTransformations from "./abstractCaseTransformations";

const abstractLitigationCaseTransformations: FormTransformations = {
  dateFields: [
    ...(abstractCaseTransformations.dateFields || []),
    { path: "lawsuitCompletedDate", type: "date" },
    { path: "courtDate.appointmentDate", type: "date" },
    { path: "customerLawsuitCompletedApprovalDate", type: "date" },
    { path: "extrajudicialCommunicationDeadline", type: "date" },
    { path: "extrajudicialCommunicationSent", type: "date" },
    { path: "extrajudicialReactionReceived", type: "date" },
    { path: "powerOfAttorney", type: "dateTime" },
    { path: "replicaFiledDate", type: "date" },
    { path: "replicaSentDate", type: "date" },
    { path: "statementOfClaimFiledDate", type: "date" },
    { path: "statementOfClaimSentDate", type: "date" },
    { path: "statementOfDefenseFiledDate", type: "date" },
    { path: "statementOfDefenseSentDate", type: "date" },
    { path: "timeBarredDate", type: "date" },
    { path: "caseInsurance.extrajudicialCoverageRequestedDate", type: "date" },
    { path: "caseInsurance.extrajudicialCoverageRequestAnsweredDate", type: "date" },
    { path: "caseInsurance.judicialCoverageRequestedDate", type: "date" },
    { path: "caseInsurance.judicialCoverageRequestAnsweredDate", type: "date" },
    { path: "principalClaimDefaultDate", type: "date" },
    { path: "accessoryClaimDefaultDate", type: "date" },
    { path: "judgementReceivedDate", type: "date" },
    { path: "promulgationOfJudgementDate", type: "date" },
    { path: "judgementEebSentDate", type: "date" },
    { path: "paymentOrderDate", type: "date" },
    { path: "enforcementOrderDate", type: "date" },
    { path: "contractDate", type: "date" },
    { path: "claimedDateClient", type: "date" },
    { path: "claimedDeadlineClient", type: "date" },
    { path: "opposingPartyLegalEntity.organization.insolvencyStartDate", type: "date" },
  ],
  numberFields: [
    ...(abstractCaseTransformations.numberFields || []),
    "leadStatus",
    "applicationStatus",
    "responsibleCourt.advoAssistId",
  ],
  timeFields: [...(abstractCaseTransformations.timeFields || []), "courtDate.appointmentTime"],
  floatFields: [
    ...(abstractCaseTransformations.floatFields || []),
    "valueInDisputeExtrajudicialPreliminary",
    "valueInDisputeExtrajudicialFinal",
    "costBearingByOpponentExtrajudicial",
    "valueInDisputeJudicialPreliminary",
    "valueInDisputeJudicialFinal",
    "netRvgAmount",
    "costBearingByOpponentFinalAbsolute",
    "courtCostsFinal",
    "costBearingByOpponentRelative",
    "principalClaim",
    "accessoryClaim",
    "overdueFees",
    "caseInsurance.deductible",
    "claimedAmountClient",
    "claimedAmountLawFirm",
  ],
  ibanFields: abstractCaseTransformations.ibanFields,
  entityIriFields: ["debtCollectionAgency.organizationEmail"],
};
export default abstractLitigationCaseTransformations;
